module.exports = __webpack_public_path__ + "static/media/address-inactive.8ed296f1.svg";